import { useQuery } from 'react-query';
import { PATIENT_MESSAGES } from '../../constants/reactQuery.keys';
import { getPatientMessages } from '../../services/PatientsMessaging';
import Id from '../../types/Id';

export function usePatientMessages({ patientId }: { patientId: Id }) {
  return useQuery([PATIENT_MESSAGES, patientId], () => getPatientMessages({ patientId }));
}
